import { Avatar, Box, Typography } from "@mui/material";
import { colors } from "../../../ui/colors";

export default function CardInfo({ icon, title, data }) {
  return (
    <Box
      display={"flex"}
      flex={1}
      alignItems={"center"}
      gap={1}
      sx={{ borderRadius: "12px", minHeight: "50px", height: "auto", py: 1, px: 0.5, bgcolor: "var(--fx-surface-base, #FFFFFF)" }}
    >
      <Avatar sx={{ width: 40, height: 40, fontSize: 20, color: colors.orange.base, backgroundColor: "transparent" }}>{icon}</Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 10, lineHeight: 1.2, mb: 0.8, whiteSpace: "normal" }} fontWeight={600}>
          {title}
        </Typography>
        <Typography fontWeight={600} sx={{ fontSize: 16, lineHeight: 1, mt: 0, color: colors.orange.base }}>
          {data}
        </Typography>
      </Box>
    </Box>
  );
}
